<template>
    <div class="pa-5 pt-2 pb-1">
        <v-list>
            <v-list-item
                v-for="item in activeExportInvoice.comments"
                :key="item.id"
                style="border-radius: 10px; margin-bottom: 5px; background-color: #F0F0F0"
            >
                <v-list-item-content>
                    <v-list-item-title style="white-space: normal;"> {{ item.comment }}</v-list-item-title>
                    <v-list-item-subtitle>
                        {{ item.first_name ? item.first_name : "" }}({{ item.date ? item.date : "" }})
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-row no-gutters>
                        <v-btn
                            icon
                            @click="deleteComment(item)"
                            v-if="user.role === 'superadmin' || (item.created_by && item.created_by == user.id)"
                        >
                            <v-icon color="bal-red">fal fa-trash-alt</v-icon>
                        </v-btn>
                    </v-row>
                </v-list-item-action>
            </v-list-item>
            <v-list-item
                v-if="activeExportInvoice && activeExportInvoice.comments && activeExportInvoice.comments.length <= 0"
            >
                <v-list-item-content>
                    <v-list-item-title>{{ "No comments found" | t }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-row v-if="!newComment">
            <v-col style="text-align:right;">
                <v-btn
                    v-if="hasPermissionForAction(PermissionsConstants.EXPORT, PermissionsConstants.VIEW)"
                    class="px-2 ml-2"
                    color="bal-red"
                    dark
                    small
                    style="min-width: 0;"
                    @click.stop="handleNewCommentClick"
                >
                    <v-icon>add</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-row v-if="newComment" align="center">
            <v-col style="text-align:right;">
                <v-textarea
                    v-model="comment"
                    :label="'Comment' | t"
                    class="text-field-item mt-2 t-spacing"
                    ref="commentArea"
                    dense
                    rows="1"
                    auto-grow
                    hide-details
                    outlined
                    type="text"
                    @keypress.enter="addNewComment"
                />
            </v-col>
            <v-col :cols="2" style="text-align:right;">
                <v-btn
                    class="px-2 ml-2 mt-2"
                    color="bal-red"
                    dark
                    small
                    style="min-width: 0;"
                    @click.stop="addNewComment"
                >
                    <v-icon>check</v-icon>
                    Send
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Store from "../../../store";
import { mapGetters, mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "comment-tab",
    data() {
        return {
            newComment: false,
            comment: null
        };
    },
    computed: {
        ...mapState("ExportSaleInvoiceStore", ["activeExportInvoice"]),
        ...mapState(["user"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        async addNewComment() {
            let result = await Store.dispatch("ExportSaleInvoiceStore/sendNewComment", this.comment);
            if (result.success === 1) {
                this.newComment = false;
                this.comment = null;
                await Store.dispatch("ExportSaleInvoiceStore/getExportInvoiceData", this.activeExportInvoice.id);
            }
        },
        async deleteComment(item) {
            if (confirm(this.t("Are you sure you want to delete this comment?"))) {
                await Store.dispatch("ExportSaleInvoiceStore/deleteComment", item.id);
                this.newComment = false;
                this.comment = null;
                await Store.dispatch("ExportSaleInvoiceStore/getExportInvoiceData", this.activeExportInvoice.id);
            }
        },
        async handleNewCommentClick() {
            this.newComment = true;
            this.$nextTick(() => {
                this.$refs.commentArea.focus();
            });
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
    font-size: smaller;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
</style>
